module.exports = __webpack_public_path__ + "img/1590987457.e495971b.jpg";